import { render, staticRenderFns } from "./ModalFavorisRecette.vue?vue&type=template&id=4a6fbf03&"
import script from "./ModalFavorisRecette.vue?vue&type=script&lang=js&"
export * from "./ModalFavorisRecette.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports